/**
 * Bridge between the API client's `onTwoFactorStepUp` hook (see `fetcherConfig`) and the
 * step-up dialog mounted in the authed layout.
 *
 * The fetcher asks for a proof when the API answers 401 with `TWO_FACTOR_STEP_UP_REQUIRED`
 * — a route demanding a fresh in-session TOTP code, not a dead session. Concurrent requests
 * share one dialog and one answer, so a burst of parallel queries never stacks modals: every
 * waiter is resolved together and each one replays its own request.
 */

export const TWO_FACTOR_STEP_UP_EVENT = 'auth:two-factor-step-up';

let waiters: Array<(verified: boolean) => void> = [];
let open = false;

/** Opens the dialog (once) and resolves when the user completes — or declines — verification. */
export function requestTwoFactorStepUp(): Promise<boolean> {
  const waiter = new Promise<boolean>((resolve) => {
    waiters.push(resolve);
  });
  if (!open) {
    open = true;
    window.dispatchEvent(new Event(TWO_FACTOR_STEP_UP_EVENT));
  }
  return waiter;
}

/** Called by the dialog on close, whichever way it ends. Resolves every pending waiter. */
export function resolveTwoFactorStepUp(verified: boolean): void {
  open = false;
  const pending = waiters;
  waiters = [];
  for (const resolve of pending) resolve(verified);
}
